<template>
  <div class='EnbMapsNets'>
    <div class="card">
      <div class="label">
        <div class="text-label">
          {{ Empresa.modelo === 'Modelo 03' ? 'Redes Sociais' : 'Widgets(Localização, Redes Sociais)' }}
        </div>
        <div class="arrow">
          <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
        </div>
      </div>
      <div class="cont-input" :class="{ continput: sublink }">
        <div class="cont-i">
          <input-reg
          v-if="Empresa.modelo !== 'Modelo 03'"
          :value="Empresa.maps"
          text="Localiação da loja(Google Maps)"
          @update:modelValue="newValue => ChangeCompany({ maps: newValue })"
          :cont="{ textAlign: 'left' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
          <input-reg
          :value="Empresa.instagram"
          text="Instagram"
          @update:modelValue="newValue => ChangeCompany({ instagram: newValue })"
          :cont="{ textAlign: 'left', marginTop: '8px' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
          <input-reg
          :value="Empresa.facebook"
          text="Facebook"
          @update:modelValue="newValue => ChangeCompany({ facebook: newValue })"
          :cont="{ textAlign: 'left', marginTop: '8px' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          />
          <input-reg
          :value="Empresa.whatsapp"
          text="Whatsapp"
          @update:modelValue="newValue => ChangeCompany({ whatsapp: newValue })"
          :cont="{ textAlign: 'left', marginTop: '8px' }"
          :label="{ marginLeft: '3px' }"
          :input="{ fontSize: '16px', padding: '2%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
          :Mask="['(##) #####-####']"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import ArrowIcon from '../Icons/ArrowIcon'
export default {
  name: 'EnbMapsNets',
  components: { InputReg, ArrowIcon },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['ChangeCompany'])
  }
}
</script>

<style scoped>
.EnbMapsNets {
  display: flex;
  margin-top: 5.8%;
}

.card {
  width: 100%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.label {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  color: #648EEA;
  font-size: 16px;
  text-align: left;
}

.text-label {
  width: 90%;
  padding: 2%;
}

input {
  margin-left: 2%;
}

.cont-input {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.continput {
  max-height: 300px;
  transition: max-height 0.2s ease-in;
}

.cont-i {
  padding: 2%;
}
</style>
